import { H2, H3, P2, P3 } from '@/lib/ui/components/Typography';
import styles from './ExamplesОbjects.module.scss';
import { useTranslation } from 'next-i18next';
import { useWindowSize } from '@/lib/hooks/useWindowSize';
import useEmblaCarousel from 'embla-carousel-react';
import { useCallback } from 'react';
import Image from "next/image";
import { CircleButton } from '@/lib/ui/components/Buttons';
import { ArrowIcon } from '@/lib/ui/icons';
import { SvgBedrooms } from '@/lib/ui/icons/complex-info/SvgBedrooms';

type ExampleCard = {
    image: string;
    title: string;
    bedrooms?: number;
    profit: string;
    rental: number;
    occupancy: string;
}

const cards: ExampleCard[]= [
    {
        image: "/images/management/card_1.webp",
        title: "apartments",
        bedrooms: 1,
        profit: "5-7%",
        rental: 21,
        occupancy: "60%"

    },
    {
        image: "/images/management/card_2.webp",
        title: "apartments",
        bedrooms: 2,
        profit: "6-9%",
        rental: 14,
        occupancy: "80%"

    },
    {
        image: "/images/management/card_3.webp",
        title: "villas",
        profit: "4-6%",
        rental: 27,
        occupancy: "63%"

    },
]

export const ExamplesОbjects = () => {
    const { t } = useTranslation("index");
    const { isMobile } = useWindowSize(1439);
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "start",
    slidesToScroll: 1,
    duration: 15,
    loop: true,
  });
  const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi]);
  const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi]);
    return (
        <div className={styles.examples}>
          <div className={styles.container}>
          <H2>{t("managementPage.еxamplesОbjectsTitle")}</H2>
          <div ref={emblaRef} className={styles.slider}>
          <ul className={styles.slider__container}>
            {cards.map((card, index) => {
              const onClick = () => {
                emblaApi && emblaApi.scrollTo(index);
              };
              return (
                <li key={index} className={styles.slide} onClick={onClick}>
                  <Image
                    src={card.image}
                    alt={""}
                    loader={({ src }) => src + " "}
                    width={isMobile ? 343 : 437}
                    height={176}
                    sizes="(max-width: 1439px) 343px, 437px"
                  />
                  <div className={styles.slide_cardFooter}>
                    <div className={styles.slide_cardInfo}>
                        <div className={styles.slide_cardInfo_top}>
                            <H3>{t(card.title)}</H3>
                            {card.bedrooms && (
                                <div className={styles.slide_cardInfo_bedrooms}>
                                    <SvgBedrooms />
                                    <P2>{`${card.bedrooms} ${card.bedrooms === 1 ? t("declinable.bedroom") : t("declinable.bedroomsFew")}`}</P2>
                                </div>
                            )}
                        </div>
                        <div className={styles.slide_cardInfo_firstCard}>
                            <P2>{t('managementPage.examplesОbjects.profit')}</P2>
                            <p className={styles.slide_cardInfo_mainText}>
                                {`${card.profit} ${t('aYear')}`}
                            </p>
                        </div>
                        <div className={styles.slide_cardInfo_secondCards}>
                            <div className={styles.slide_cardInfo_card}>
                                <P2 className={styles.slide_cardInfo_mainTitle}>{t('managementPage.examplesОbjects.rental')}</P2>
                                <p className={styles.slide_cardInfo_mainText}>
                                    {`${card.rental} ${card.rental === 21 ? t('declinable.day') : t('declinable.days')}`}
                                </p>
                            </div>
                            <div className={styles.slide_cardInfo_card}>
                                <P2>{t('managementPage.examplesОbjects.occupancy')}</P2>
                                <p className={styles.slide_cardInfo_mainText}>
                                    {card.occupancy}
                                </p>
                            </div>
                        </div>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
          <div className={styles.slider__buttons}>
            <CircleButton
              name="scroll to previous"
              as={"button"}
              content={<ArrowIcon />}
              styleType={"secondary"}
              theme={"dark"}
              onClick={scrollPrev}
              className={styles.slider__cardPrev}
            />
            <CircleButton
              name="scroll to next"
              as={"button"}
              content={<ArrowIcon isRight />}
              styleType={"secondary"}
              theme={"dark"}
              onClick={scrollNext}
              className={styles.slider__cardNext}
            />
          </div>
        </div>
          </div>
          
        </div>
    )
}